<template>
	<div class="cgoods-list flex-col">
		<el-row class="cgoods-item" :gutter="30" v-for="(item, index) in goodslist" :key="index">
			<el-col :span="4">
				<el-image class="cgoods-img" fit='scale-down' :src="$utils.set400Img(item.picUrl)" :data-goodsid="item.goodsId" @click="gotoGoodsDetail"></el-image>
			</el-col>
			<el-col :span="10" style="position: relative;">
				<div class='goods-box' :data-goodsid="item.goodsId" @click="gotoGoodsDetail">
					<el-tooltip :content="item.goodsName" placement="top" :open-delay="300">
						<div class="cgoods-name text-ellipsis_twoline">{{item.goodsName}}</div>
					</el-tooltip>
					<div class="cspec-name text-ellipsis_oneline" v-if="isShowGoodsNo">{{item.goodsNo}}</div>
					<el-tooltip v-if="(isShowSingleSpec && item.isMulti=='0')|| item.isMulti!='0'" :content="item.skuName" placement="top" :open-delay="300">
						<div class="cspec-name text-ellipsis_oneline" style='height: 20px;'>
							{{(isShowSingleSpec && item.isMulti=='0')|| item.isMulti!='0'?item.skuName:''}}
						</div>
					</el-tooltip>
					<div v-else class="cspec-name text-ellipsis_oneline" style='height: 20px;'>
						{{(isShowSingleSpec && item.isMulti=='0')|| item.isMulti!='0'?item.skuName:''}}
					</div>
				</div>
				<div class="flex-row barcode-class" style="">
					<div class="cspec-name" v-if="isShowGoodsBarCode && item.barcode">
						{{ $t('trade.GoodsList.009719-3', [item.barcode]) }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					</div>
					<div class="cspec-name" v-if="item.serialNos&&item.serialNos.length>0">
						{{ $t('trade.GoodsListJmc.156025-1', [item.serialNos.toString()]) }}
					</div>
				</div>
			</el-col>
			<el-col :span="6">
				<div class="cgoods-price">
					<span v-show="item.sellPrice > 0 || item.sellPoint == 0">{{$currency.symbol}}{{$utils.filterTrailingZeros(item.sellPrice)}}</span>
					<span v-show="(item.sellPrice && item.sellPrice != 0) && item.sellPoint > 0"> + </span>
					<span v-show="item.sellPoint > 0">{{item.sellPoint}}</span>
					<span v-show="item.sellPoint > 0" class="sscore-text">{{ $t('home.home.336045-4') }}</span>
				</div>
			</el-col>
			<el-col :span="4">
				<div class="cgoods-price">x {{item.sellCount}} {{item.unit}}</div>
				<!-- 加入购物车按钮 -->
				<div class="add-cart-btn-box" style="position:absolute;right:10px;bottom:10px;">
					<el-button type="button" class="el-button el-button--default is-plain" size="mini" @click.stop="addSingleGoodsToCart(item)">{{ $t('goods.WholeSaleGoodsItem.833487-12') }}</el-button>
				</div>
			</el-col>

		</el-row>

	</div>
</template>

<script>
	import {
		getParamByKeysFromCache
	} from '../../utils/api-utils/api-params.js';
	import goodsUtils from '../../utils/api-utils/api-goods.js';
	import tradeUtils from '../../utils/api-utils/api-trade.js';
	export default {
		name: "goods-list",
		components: {
		},
		props: {
			goodslist: {
				type: Array,
				default: function() {
					return [];
				}
			},
			isShowSingleSpec: {
				type: Boolean,
				default: true
			},
			// 订单编号，用于获取订单详情判断预售/拼团状态
			tradeNo: {
				type: String,
				default: ''
			},
			// 是否直接禁止加购（如预售/拼团订单）
			isForbidAddToCart: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return{
				isShowGoodsNo: false,
				isShowGoodsBarCode: true,
			} 
		},
		async mounted() {
			let paramList = getParamByKeysFromCache('isShowGoodsNo,isShowGoodsBarCode');
			// 是否展示商品编号
			this.isShowGoodsNo = paramList.isShowGoodsNo == '1';
			this.isShowGoodsBarCode = paramList.isShowGoodsBarCode != '0';
		},
		methods: {
			/**
			 * 跳转商品详情
			 * @param {Object} e
			 */
			gotoGoodsDetail(e) {
				let goodsId = e.currentTarget.dataset.goodsid;
				let encode = window.btoa(window.encodeURIComponent(goodsId))
				this.$router.push({
					name: 'goodsdetail',
					query: {
						id: encode
					}
				});
			},

			/**
			 * 单个商品加入购物车
			 * @param {Object} goodsItem 商品信息
			 */
			async addSingleGoodsToCart(goodsItem) {
				// 如果已经禁止加购（如预售/拼团订单），直接返回
				if (this.isForbidAddToCart) {
					console.log('addSingleGoodsToCart - 已被禁止加购');
					return;
				}

				// 检查订单是否是预售或拼团订单
				let isTeamBuy = false;
				let isPresale = false;
				let jmallTradeInfo = null;

				if (this.tradeNo) {
					try {
						// 获取吉商城订单详情判断
						jmallTradeInfo = await tradeUtils.getJmallTradeDetail(this.tradeNo);

						if (jmallTradeInfo) {
							isTeamBuy = jmallTradeInfo.isTeamBuy == 1;
							isPresale = jmallTradeInfo.isPresale == 1;
							console.log('addSingleGoodsToCart - isTeamBuy:', isTeamBuy, 'isPresale:', isPresale);

							// 检查商品是否为预售活动商品
							if (jmallTradeInfo.tradeGoodsList && jmallTradeInfo.tradeGoodsList.length > 0) {
								let matchGoods = jmallTradeInfo.tradeGoodsList.find(
									t => t.goodsId == goodsItem.goodsId && (t.specId == goodsItem.skuId || t.specId == goodsItem.specId)
								);
								console.log('addSingleGoodsToCart - matchGoods:', matchGoods);
								if (matchGoods) {
									isPresale = isPresale || (matchGoods.actType == 3);
								}
							}
						}
					} catch (e) {
						console.error('addSingleGoodsToCart - 检查订单类型失败:', e);
					}
				}

				// 拼团订单不允许加购
				if (isTeamBuy) {
					console.log('addSingleGoodsToCart - 拼团订单不允许加购');
					this.$message.error(this.$t("trade.tradelist.465643-12"));
					return;
				}

				// 预售订单不允许加购
				if (isPresale) {
					console.log('addSingleGoodsToCart - 预售订单不允许加购');
					this.$message.error(this.$t("trade.tradelist.465643-34"));
					return;
				}

				// 从吉商城订单详情中获取完整的商品信息
				let addCartGoods = null;
				if (jmallTradeInfo && jmallTradeInfo.tradeGoodsList) {
					addCartGoods = jmallTradeInfo.tradeGoodsList.find(
						t => t.goodsId == goodsItem.goodsId && (t.specId == goodsItem.skuId || t.specId == goodsItem.specId)
					);
				}

				// 如果找到了吉商城的商品信息，使用它的数据
				if (addCartGoods) {
					// 构建加购数据
					let cartGoodsInfo = {
						goodsId: addCartGoods.goodsId,
						specId: addCartGoods.specId,
						goodsCount: goodsItem.sellCount,
						unitName: addCartGoods.unit || '',
						actType: addCartGoods.actType,
						actId: addCartGoods.actId || "",
						packageGoodsId: addCartGoods.packageGoodsId || '',
						packageSpecId: addCartGoods.packageSpecId || '',
						cartType: 0,
						isAddShopCart: true
					};
					// 调用加购接口
					let cartIds = await goodsUtils.addShoppingCartBatch([cartGoodsInfo]);
					if (!cartIds || cartIds == 0) {
						//this.$message.error(this.$t("common.prompt.addToCartFailure"));
						this.$message.error('商品已下架，看看其他商品吧~')
						return;
					}
					this.$message.success(this.$t("common.prompt.addToCartSuccess"));
					// 更新头部购物车数量
					this.$eventBus.$emit("updateHeaderShopCartCount");
				} else {
					// 如果没找到，使用原始商品数据
					let cartGoodsInfo = {
						goodsId: goodsItem.goodsId,
						specId: goodsItem.skuId || goodsItem.specId,
						goodsCount: goodsItem.sellCount,
						unitName: goodsItem.unit || '',
						actType: goodsItem.actType,
						actId: goodsItem.actId || "",
						packageGoodsId: goodsItem.packageGoodsId || '',
						packageSpecId: goodsItem.packageSpecId || '',
						cartType: 0,
						isAddShopCart: true
					};
					// 调用加购接口
					let cartIds = await goodsUtils.addShoppingCartBatch([cartGoodsInfo]);
					if (!cartIds || cartIds == 0) {
						//this.$message.error(this.$t("common.prompt.addToCartFailure"));
						this.$message.error('商品已下架，看看其他商品吧~')
						return;
					}
					this.$message.success(this.$t("common.prompt.addToCartSuccess"));
					// 更新头部购物车数量
					this.$eventBus.$emit("updateHeaderShopCartCount");
				}
			},
		}
	}
</script>

<style scoped="scoped">
	.cgoods-list :last-child {
		border: none;
	}

	.cgoods-item {
		display: flex;
		align-items: center;
		padding: 20px;
		/* border-bottom: 1px solid #dedede; */
	}

	.cgoods-img {
		width: 100%;
		height: 110px;
	}

	.cspec-name {
		font-size: 15px;
		color: #666;
		word-break: break-all;
	}

	.cgoods-name {
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
		word-break: break-all;
	}

	.sscore-text {
		font-size: 15px;
		margin-left: 3px;
	}

	.goods-box {
		min-height: 70px;
		height: 110px;
	}

	.barcode-class {
		position: absolute;
		bottom: 3px;
		width: 100%;
	}

	.add-cart-btn-box {
		margin-top: 10px;
		display: flex;
		justify-content: flex-end;
	}
	.el-button {
		display: inline-block;
		line-height: 1;
		white-space: nowrap;
		cursor: pointer;
		background: #FFF;
		border: 1px solid #DCDFE6 !important;
		color: #606266;
		-webkit-appearance: none;
		text-align: center;
		box-sizing: border-box;
		outline: 0;
		margin: 0;
		transition: .1s;
		font-weight: 500;
		padding: 12px 20px;
		font-size: 14px;
		border-radius: 4px;
	}
</style>